import { Component } from '@angular/core';

import { AuthFacade } from '../../store/auth.facade';

@Component({
  standalone: false,
  selector: 'app-auth-password-reset-email',
  templateUrl: './password-reset-email.component.html',
  styleUrls: ['./password-reset-email.component.scss']
})
export class PasswordResetEmailComponent {
  public loginValid = true;
  public email = '';
  

  isLoading$ = this.authFacade.isLoadingLogin$;
  showLoginError$ = this.authFacade.hasLoginError$;

  constructor(private authFacade: AuthFacade) { }

  onSubmit() {
    this.authFacade.passwordResetEmail(this.email);
  }
}
